import chalk from 'chalk';

class Logger {
  styles = {
    variant: chalk.bgHex("#9fccf5").hex("#000").bold,
    product: chalk.bgHex("#5678fd").hex("#000").bold,
    code: chalk.bgHex("#618b4c").hex("#000").bold,
    tag: chalk.bgHex("#b9b6b1").hex("#000").bold,
    properties: chalk.italic
  };

  constructor() {

  }

  variant(variant) {
    return `Variant ${this.styles.variant(` ${variant.title || "Unknown Title"} (${variant.id}) `)}`
  }

  product(product) {
    return `Product ${this.styles.product(` ${product.title || "Unknown Title"} (${product.id || "Unknown ID"}) `)}`
  }

  code(code) {
    return `Discount Code ${this.styles.code(` ${code} `)}`
  }

  tag(tag) {
    return `Tag ${this.styles.tag(` [${tag}] `)}`
  }

  properties(properties) {
    return `Properties ${this.styles.properties(`${JSON.stringify(properties)}`)}`
  }
}

export default Logger;